import React, { useRef } from "react";

import RegisterAuditory from "@auditory/component/RegisterAuditory";
import SectionPlans from "../components/SectionPlans";
import { SectionAction } from "../components/SectionAction";
import { AUDITORY_MODEL, PLANS_MODEL } from "../models/model";
import { PlansProvider } from "../context/PlansContext";
import helpers from "@/utils/helpers";
import { getProductOptions } from "@/utils/product";
import useScrollToPosition from '@/hooks/useScrollToPosition'

const StepPlans = () => {
  useScrollToPosition();
  const sectionPlansRef = useRef();
  const { digitalDataProductName } = getProductOptions();

  const callAnalyticsAction = () => {
    helpers.getTagAction(
      digitalDataProductName,
      "Cotización",
      "click",
      "Ver detalle",
      "trackAction"
    );
  };

  return (
    <PlansProvider>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <SectionPlans {...PLANS_MODEL} ref={sectionPlansRef} analyticsDetailAction={callAnalyticsAction} />
      <SectionAction
        {...PLANS_MODEL}
        validateForm={() => sectionPlansRef.current?.validateForm()}
        analyticsDetailAction={callAnalyticsAction}
      />
    </PlansProvider>
  );
};

export default StepPlans;
